import { Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./home/home').then(m => m.Home)
  },
  {
    path: 'generate-qr',
    loadComponent: () => import('./qr-code/qrcode-view/qrcode-view').then(m => m.QRCodeView)
  },
  {
    path: 'privacy-policy',
    loadComponent: () => import('./common/privacy-policy/privacy-policy').then(m => m.PrivacyPolicy)
  },
  {
    path: 'terms-of-service',
    loadComponent: () => import('./common/terms-of-service/terms-of-service').then(m => m.TermsOfService)
  },
];
